import { useMediaQuery, useTheme, Breakpoint } from "@mui/material"

export const useIsBreakpointUp = (breakpoint: Breakpoint | number) => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.up(breakpoint))
}
